// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types

export default class StatusCodeError extends Error {
    constructor(statusCode = 404, ...params) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, StatusCodeError);
        }

        this.name = 'StatusCodeError';
        // Custom debugging information
        this.statusCode = statusCode;
        this.date = new Date();
    }
}
